import type { PropsWithChildren } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { WalletConnectStateContext } from './context';
import { useAutoConnect, useDisconnect } from './hooks';
import type { WalletConnectState } from './types';

export const WalletConnectStateProvider = ({
  chains,
  wallets,
  children,
  chainId,
}: PropsWithChildren<Pick<WalletConnectState, 'chains' | 'wallets' | 'chainId'>>) => {
  const { disconnectAsync } = useDisconnect();

  const [isReconnecting, setIsReconnecting] = useState(true);

  const handleReconnectComplete = useCallback(() => setIsReconnecting(false), []);

  const contextValue = useMemo(
    () => ({
      chains,
      wallets,
      isReconnecting,
      disconnectAsync,
      chainId,
    }),
    [chains, wallets, isReconnecting, disconnectAsync, chainId],
  );

  useAutoConnect(wallets, chains, handleReconnectComplete);

  return <WalletConnectStateContext.Provider value={contextValue}>{children}</WalletConnectStateContext.Provider>;
};
